

// Libs
import { defineComponent,ref } from 'vue';

// Compone
import PsModal from '@/components/core/modals/PsModal.vue';
import PsLabel from '@/components/core/label/PsLabel.vue';
import PsButton from '@/components/core/buttons/PsButton.vue';
import PsInput from '@/components/core/input/PsInput.vue';

export default defineComponent({
    name: "InputEmailModal",
    components: {
        PsModal,
        PsLabel,
        PsButton,
        PsInput,
    },
    setup() {

        const psmodal = ref();
        const userEmail = ref();
        const validationEmail = ref(false);

        let okClicked: Function;
        let cancelClicked: Function;

        function validateEmail(e) {
            const pattern = /^([a-zA-Z0-9.]+)@([a-zA-Z0-9]+)\.([a-zA-Z]{2,5})$/;
            const res = pattern.test(e.target.value);
            if (!res) {
                validationEmail.value = true;
            } else {
                validationEmail.value = false;
            }
        }

        function actionClicked(status) {
            psmodal.value.toggle(false);
            if(status == 'yes') {
                if(userEmail.value == ''){
                    validationEmail.value = false;
                }else{
                    okClicked(userEmail.value);     
                }
            }else {
                cancelClicked();
            }
            
        }
     
        async function openModal(okClickedAction: Function,cancelClickedAction : Function) {

            okClicked = okClickedAction;
            cancelClicked= cancelClickedAction;    

            psmodal.value.toggle(true);
                        
        }



        return {
            psmodal,
            openModal,
            userEmail,
            validateEmail,
            validationEmail,
            actionClicked
        }
    },
})
